/**
 * Light or dark, before the page draws (loaded as a plain script in <head>): the one you picked on
 * this site (the button at the top), else your system's — and dark when the browser can't tell
 * (some in-app browsers, like Discord's on phones, don't say).
 */
export const THEME_KEY = 'omni-torn.theme';
export type ThemeChoice = 'auto' | 'light' | 'dark';

export function savedTheme(): ThemeChoice {
  try {
    const t = localStorage.getItem(THEME_KEY);
    return t === 'light' || t === 'dark' ? t : 'auto';
  } catch {
    return 'auto';
  }
}

/** What "auto" means here: light only when the system clearly says light; otherwise dark. */
export function systemTheme(): 'light' | 'dark' {
  try {
    const q = (s: string) => window.matchMedia(`(prefers-color-scheme: ${s})`).matches;
    // A browser that says nothing (no preference) gets dark.
    return q('light') && !q('dark') && !q('no-preference') ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(choice: ThemeChoice): void {
  // Always set it: "auto" resolves now (and again when the system changes), so a browser that
  // doesn't say gets dark rather than whatever the stylesheet guesses.
  document.documentElement.dataset.theme = choice === 'auto' ? systemTheme() : choice;
  document.documentElement.dataset.themeChoice = choice;
}

